import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=5efc6a1e&"
var script = {}
import style0 from "./BigScreen.vue?vue&type=style&index=0&id=5efc6a1e&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports